import Vue from "vue";
import Router from "vue-router";
import store from "./store.js";
const Index = r => require.ensure([], () => r(require("./components/index.vue")), 'index');
const Home = r => require.ensure([], () => r(require("./components/home.vue")), 'home');
const BlockChain = r => require.ensure([], () => r(require("./components/blockChain/index.vue")), 'blockChain');
const internetCourt = r => require.ensure([], () => r(require("./components/internetCourt/index.vue")), 'internetCourt');
const validateQuery = r => require.ensure([], () => r(require("./components/validateQuery/index.vue")), 'validateQuery');
const validateShow = r => require.ensure([], () => r(require("./components/validateQuery/validateShow.vue")), 'validateShow');
const evidenceExtraction = r => require.ensure([], () => r(require("./components/evidenceExtraction/index.vue")), 'evidenceExtraction');
const extractionDetail = r => require.ensure([], () => r(require("./components/evidenceExtraction/extractionDetail.vue")), 'extractionDetail');
const detailList = r => require.ensure([], () => r(require("./components/evidenceExtraction/detailList.vue")), 'detailList');
const detailInfo = r => require.ensure([], () => r(require("./components/evidenceExtraction/detailInfo.vue")), 'detailInfo');
const Solution = r => require.ensure([], () => r(require("./components/solution.vue")), 'solution');
const Technology = r => require.ensure([], () => r(require("./components/technology.vue")), 'technology');
const Contact = r => require.ensure([], () => r(require("./components/contact.vue")), 'contact');
const Certificate = r=>require.ensure([], () => r(require("./components/common/Certificate.vue")), 'contact');
const CertificateN = r=>require.ensure([], () => r(require("./components/common/NoAuthCertificate.vue")), 'contact');
// 联盟动态
const ProductActivity = r=>require.ensure([], () => r(require("./components/productActivity/ProductActivity.vue")), 'productActivity');
const ProductDetails = r => require.ensure([], () => r(require("./components/productActivity/ProductDetails")), 'productDetails');
// 开放平台
const OpenPlatform = r=>require.ensure([], () => r(require("./components/openPlatform/index.vue")), 'openPlatform');
const OpenPlatformDetail = r=>require.ensure([], () => r(require("./components/openPlatform/detail.vue")), 'openPlatformDetail');
const EnterpriseAuth = r => require.ensure([], () => r(require("./components/enterpriseAuth/enterpriseAuth.vue")), 'contact');
const UserAgreement = r => require.ensure([], () => r(require("./components/enterpriseAuth/UserAgreement.vue")), 'contact');
Vue.use(Router);
let childrenRouter = [{
    path: 'home',
    component: Home,
  },
  {
    path: 'blockChain',
    component: BlockChain,
  },
  {
    path: 'internetCourt',
    component: internetCourt,
  },
  {
    path: 'validateQuery',
    component: validateQuery,
  },
  {
    path: 'validateShow',
    component: validateShow,
  },
  {
    path: 'evidenceExtraction',
    component: evidenceExtraction,
  },
  {
    path: 'extractionDetail',
    component: extractionDetail,
    children: [
      {
        path: '/',
        redirect: "detail",
      },
      {
        path: 'list',
        component: detailList
      },
      {
        path: 'detail',
        component: detailInfo
      },
      {
        path:'certificate',
        component :CertificateN
      },
    ]
  },
  
  {
    path: 'solution',
    component: Solution,
  },
  {
    path: 'technology',
    component: Technology,
  },
  {
    path: 'contact',
    component: Contact,
  },
  //申请企业认证
  {
    path: 'enterpriseAuth',
    component: EnterpriseAuth,
  },
  //用户注册协议
  {
    path: 'agreement',
    component: UserAgreement,
  },
  {
    path: 'activityProduct', // 联盟动态
    component: ProductActivity,
  },
  {
    name: 'detailsProduct',
    path: 'detailsProduct', // 联盟动态详情
    component: ProductDetails,
  },
  {
    path: 'openPlatform', // 开放平台
    component: OpenPlatform,
  },
  {
    name: 'detailsOpenPlatform',
    path: 'detailsOpenPlatform', // 开放平台详情
    component: OpenPlatformDetail,
  },
];
let handlerRoute = function (to, from, next, flag) {
  store.commit("setLanType", flag);
  next();
};

const router = new Router({
  mode: "history",
  base: "/",
  routes: [{
      path: "/",
      redirect: "/cn",
    },
    {
      path: "/cn",
      component: Index,
      redirect: "/cn/home",
      children: childrenRouter,
      beforeEnter: (to, from, next) => {
        handlerRoute(to, from, next, 'cn');
      }
    },
    {
      path: "/en",
      redirect: "/en/home",
      component: Index,
      children: childrenRouter,
      beforeEnter: (to, from, next) => {
        handlerRoute(to, from, next, 'en');
      }
    }
  ]
});
//拦截所有前端请求
router.beforeEach((to, from, next) => {
  if (to.path.indexOf('validateQuery') > 0 || to.path.indexOf('evidence') > 0 ||  to.path.indexOf('extractionDetail') > 0 ) {
    store.commit('changeFooter', '2')
    next();
  } else if(to.path.indexOf('javascript:;') > 0){
    return;
  }else{
    store.commit('changeFooter', '1')
    next()
  }
});

export default router